document.addEventListener("click", function (e) {
  if (!e.target || !(e.target instanceof HTMLElement)) return;

  const target = e.target.closest("[data-dfg]");
  if (!target || !(target instanceof HTMLElement) || !target.dataset.dfg) return;

  const url = decodeURIComponent(atob(target.dataset.dfg.split("").reverse().join("")));

  if (target.dataset.b === "1" || e.ctrlKey) {
    const newWindow = window.open(url, "_blank");
    newWindow?.focus();
  } else {
    window.location.href = url;
  }
});